export const LEGAL_OVERRIDES = {};
